import React from "react";
import "./index.css"; // Make sure to create a corresponding CSS file
import { MDBCol, MDBRow } from "mdbreact";

const VideoInstructionsMobile = ({ setSection }) => {
  return (
    <div
      style={{
        backgroundColor: "#201e23", // Added this line
        width: "90vw",
      }}
      className="video-instructions-container"
    >
      <MDBRow style={{ marginTop: 10 }} className="content">
        <MDBCol
          style={{ paddingLeft: 15 }}
          size="12"
          className="recommendations"
        >
          <p
            style={{
              fontFamily: "CSSemiBold",
              color: "white",
              fontSize: "4vw",
              textAlign: "center",
            }}
          >
            ✅ Recommended
          </p>
          <ul
            style={{
              fontFamily: "CSMedium",
              color: "white",
              width: "90vw",
              marginLeft: "-4vw",
            }}
          >
            <li>Submit at least 2 min of footage</li>
            <li style={{ marginTop: 5 }}>Use a high resolution camera</li>
            <li style={{ marginTop: 5 }}>
              Record in a well-lit, quiet environment
            </li>
            <li style={{ marginTop: 5 }}>Look directly into the camera</li>
            <li style={{ marginTop: 5 }}>
              Pause between each sentence with your mouth closed
            </li>
            <li style={{ marginTop: 5 }}>
              Use natural gestures and keep hands below your chest
            </li>
          </ul>
        </MDBCol>

        <MDBCol size="12" className="avoid">
          <p
            style={{
              fontFamily: "CSSemiBold",
              color: "white",
              fontSize: "4vw",
              textAlign: "center",
              marginTop: 19,
            }}
          >
            ❌ Things to avoid
          </p>
          <ul
            style={{
              fontFamily: "CSMedium",
              color: "white",
              width: "90vw",
              marginLeft: "-4vw",
            }}
          >
            <li>Stitches or cuts your footage</li>
            <li style={{ marginTop: 5 }}>Talking without pauses</li>
            <li style={{ marginTop: 5 }}>Changing positions while recording</li>
            <li style={{ marginTop: 5 }}>Loud background noise</li>
            <li style={{ marginTop: 5 }}>
              Shadows and overexposure on your face
            </li>
            <li style={{ marginTop: 5 }}>
              Diverting your gaze or looking around
            </li>
            <li style={{ marginTop: 5 }}>Hand gestures above the chest</li>
            <li style={{ marginTop: 5 }}>Use of pointing gestures</li>

            {/* Add the rest of the recommendations here */}
          </ul>
        </MDBCol>
      </MDBRow>

      <div className="tips">
        <p style={{ fontFamily: "CSMedium" }}>
          💡 Tips: Feel free to talk about any topic in the language of your
          choice. Just relax, be yourself, look into the camera, and we will
          take care of the rest 😊
        </p>
      </div>

      <div
        onClick={() => {
          window.scrollTo({
            top: 0,
          });
          setSection(2);
        }}
        className="next-step"
      >
        <button styl>Next Step</button>
      </div>
    </div>
  );
};

export default VideoInstructionsMobile;
